import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import BCVantaitable from "components/Tonghopbaocao/Maubaocao19/BCVantaitable.js";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import Config from "conFig.js";
const Maubaocao19ct = React.memo(function Maubaocao19ct(props) {
  const classes = useStyles();
  const { thangnam, thaydoidexuat } = props;
  const [tendonvi, setTendonvi] = React.useState("");
  const [khokhan, setKhokhan] = React.useState("");
  const [dexuat, setDexuat] = React.useState("");
  const [data, setData] = React.useState({});
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Phuongtien/bcpl19dkkdvt?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setData(data[0]);
            setTendonvi(data[0].tendonvivantai);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const getkhokhandexuat = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Canhbao/getbckhokhandexuatthang?thang=" +
        thang +
        "&baocao_id=2" +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setKhokhan(data[0].khokhan);
            setDexuat(data[0].dexuat);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
    getkhokhandexuat();
  }, [thangnam, thaydoidexuat]);
  return (
    <GridContainer>
      <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={8}>
        <GridContainer style={{ border: "0.1px solid #4f7edb" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%" }}>
              <a className={classes.tieudecenter}>
                BÁO CÁO KẾT QUẢ HOẠT ĐỘNG VẬN CHUYỂN HÀNG HÓA
              </a>
              <a className={classes.tieudecenter}>
                Kính gửi: Sở Xây dựng Tỉnh Gia Lai
              </a>
              <a className={classes.tieudeleft}>
                Thực hiện chế độ báo cáo quy định tại Thông tư số ..... của Bộ
                trưởng Bộ giao thông vận tải quy định về tổ chức, quản lý hoạt
                động kinh doanh vận tải bằng xe ô tô và dịch vụ hỗ trợ vận tải
                đường bộ, {tendonvi} báo cáo kết quả hoạt động vận tải của đơn
                vị trong tháng {String(thangnam.$M + 1).padStart(2, "0")} năm
                {" " + thangnam.$y} như sau:
              </a>
              <a className={classes.tieudeleftbold}>
                1. Kết quả hoạt động vận chuyển hàng hóa:
              </a>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <BCVantaitable data={data} />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleftbold}>
              2. Thuận lợi, khó khăn: {khokhan}
            </a>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <a className={classes.tieudeleftbold}>
              3. Đề xuất, kiến nghị: {dexuat}
            </a>
          </GridItem>
        </GridContainer>
      </GridItemLogin>
      <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
    </GridContainer>
  );
});

Maubaocao19ct.propTypes = {
  thangnam: PropTypes.object,
  thaydoidexuat: PropTypes.number,
};
export default Maubaocao19ct;
